import type {
  DeleteBoardsDocumentsRequestType,
  DeleteBoardsDocumentsResponseType,
} from 'entities/document/api/types';
import { apiAuthClient } from 'shared/api/lib/apiAuthClient';

export const deleteBoardsDocuments = async ({
  boardId,
  ...data
}: DeleteBoardsDocumentsRequestType) => {
  const url = `/api/v2/boards/${boardId}/documents`;
  const result = await apiAuthClient.delete<DeleteBoardsDocumentsResponseType>(
    url,
    {
      data,
    },
  );

  return result.data;
};
